<template>
  <span>
    <base-button
      :type="'danger'"
      :icon="isIcon"
      :disabled="isReadOnly || isPartnerAccount"
      size="sm"
      :class="isIcon ? 'btn-link' : 'btn_extra_small btn_info'"
      @click.native="modals.notice = true"
    >
      <slot name="modal-link"></slot>
    </base-button>
    <!-- small modal -->
    <modal
      :show.sync="modals.notice"
      headerClasses="justify-content-center"
      type="notice"
    >
      <div slot="header">
        <h3>Delete Fund Citation</h3>
      </div>
      <div class="container text-center">
        <p>ARE YOU SURE YOU WANT TO DELETE THIS ITEM?</p>
      </div>
      <template slot="footer">
        <div class="container alert_footer">
          <base-button
            type="danger"
            class="alert_footer_button btn_extra_small btn_info mr-4"
            @click.native="modals.notice = false"
          >
            Close
          </base-button>
          <base-button
            type="primary"
            class="alert_footer_button btn_extra_small btn_info"
            @click.native="confirm"
          >
            Confirm
          </base-button>
        </div>
      </template>
    </modal>
  </span>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { BaseButton, Modal } from "@/components";

export default {
  name: "fund-citation-delete",
  props: {
    id: {
      type: Number,
      default: 0,
    },
    isIcon: {
      type: Boolean,
      default: false,
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      modals: {
        notice: false,
      },
    };
  },
  components: {
    BaseButton,
    Modal,
  },
  computed: {
    ...mapGetters({
      isPartnerAccount: "authentication/isPartnerAccount"
    }),
  },
  methods: {
    ...mapActions({
      getFundCitations: "fundCitation/getFundCitations",
      removeFundCitation: "fundCitation/removeFundCitation",
      getReconciliationStatus: "reconciliationStatus/getReconciliationStatus",
      getFundCitationStatus: "fundCitation/getFundCitationStatus",
      getLineItemInvoiceStatus: "lineItemInvoice/getLineItemInvoiceStatus",
      getReplacementItemInvoiceStatus: "replacementItemInvoice/getReplacementItemInvoiceStatus",
    }),
    confirm(e) {
      let ctx = this;
      ctx
        .removeFundCitation(ctx.id)
        .then((response) => {
          ctx.getFundCitations(ctx.$route.params.id);
          ctx.getReconciliationStatus(this.$route.params.id);
          ctx.getFundCitationStatus(this.$route.params.id);
          ctx.getLineItemInvoiceStatus(ctx.$route.params.id);
            ctx.getReplacementItemInvoiceStatus(ctx.$route.params.id);
          ctx.modals.notice = false;
        })
        .catch((error) => {
          this.$emit("deleteErrorOccurred", error);
          this.modals.notice = false;
        });
    },
  },
};
</script>
